<template>
  <div class="trx-box">
    <table cellspacing="0">
      <thead>
        <th class="a-left">Date</th>
        <th class="a-left">Amount</th>
        <th class="a-left">Stripe Charge ID</th>
        <th class="a-center">Transaction Type</th>
        <th class="a-center">Status</th>
        <th class="a-center">URL</th>
      </thead>

      <tr v-for="(t, i) in trx" :key="i" v-show="!loading">
        <td class="a-left">{{t.created}}</td>
        <td class="a-left">${{priceFormat(t.amount)}}</td>
        <td class="a-left stripe-id">{{t.stripeChargeId}}</td>
        <td class="a-center"><b>{{t.trxType}}</b></td>
        <td class="a-center"><span :class="['status', t.status]">{{t.status}}</span></td>
        <td class="a-center">
          <span v-if="!t.url">--</span>
          <a v-else :href="t.url" target="_blank"><i class="fa fa-link"></i></a>
        </td>
      </tr>

      <tr v-if="!loading && !trx.length">
        <td class="a-center loading" colspan="6">
          No transaction for this flight...
        </td>
      </tr>

      <tr v-if="loading">
        <td class="a-center loading" colspan="6">
          <i class="fas fa-spinner fa-spin"></i>
          Getting Transactions...
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'

export default {
  name: 'trx',
  data () {
    return {
      lastID: '',
      loading: false,
      error: {
        show: false,
        msg: ''
      }
    }
  },
  computed: {
    id () { return this.$route.params.id },
    trx () { return this.$store.state.flightDetails.trx.list },
  },
  methods: {
    getTrx () {
      let self = this
      if (self.loading || self.id === self.lastID) return

      self.loading = true
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/transaction`, {
        token: self.$store.state.session.sessionToken,
        d2dId: parseInt(self.id),
        pageSize: 30,
        order: 'createTime',
        desc: true,
        pageNum: 1,
      }, res => {
        if (res.error) {
          self.$store.commit('flightDetails/setTrxData', {list: []})
          self.error = {
            show: true,
            msg: res.error.message
          }
          self.loading = false
          return
        }

        self.lastID = self.id
        let trx = []
        res.list.forEach(t => {
          trx.push({
            id: t.id,
            created: moment(t.createdUTC).format('MM/DD/YYYY hh:mmA'),
            amount: t.amount / 100,
            stripeChargeId: t.stripeChargeId,
            status: t.status,
            trxType: t.trxType,
            url: t.stripeChargeId ? `${CONFIG.Stripe.paymentURL}${t.stripeChargeId}` : ''
          })
        })
        self.$store.commit('flightDetails/setTrxData', {list: trx})
        self.loading = false
      })
    },
    priceFormat (data) {
      return parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
    },
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.trx-box{
  background: #fbfbfb;
  border-radius: 2px;
  border: 1px solid #ddd;
  box-shadow: 1px 1px 2px rgba(0,0,0, .1);
  margin-bottom: 20px;
  padding: 20px;
}
table{
  border: 1px solid #999;
  width: 100%;
  background: #fff;

  thead{
    font-weight: 600;
    line-height: 1;
    background: #eaeaea;
    color: #333;
    font-size: 13px;

    th{
      padding: 10px;
    }
  }
  td{
    vertical-align: top;
    padding: 10px;
    font-size: 14px;
  }
  tr:nth-child(even):not(.head) td{
    background: #f7f7f7;
  }
  .stripe-id{
    color: #777;
    font-style: italic;
  }
}
.a-left{
  text-align: left;
}
.a-center{
  text-align: center;
}
.status{
  padding: 3px 10px;
  font-size: 12px;
  background: #333;
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: .6px;

  &.PAID, &.SUCCESS{
    background: #3bbb3b;
  }
}
.loading{
  font-size: 21px;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightDetails/trx.vue